import { render, staticRenderFns } from "./AveineReferentialList.vue?vue&type=template&id=10b84d7e&scoped=true"
import script from "./AveineReferentialList.vue?vue&type=script&lang=js"
export * from "./AveineReferentialList.vue?vue&type=script&lang=js"
import style0 from "./AveineReferentialList.vue?vue&type=style&index=0&id=10b84d7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b84d7e",
  null
  
)

export default component.exports